import { render, staticRenderFns } from "./BaseInputReadOnlyTextField.vue?vue&type=template&id=f8338c9a&scoped=true&"
import script from "./BaseInputReadOnlyTextField.vue?vue&type=script&lang=js&"
export * from "./BaseInputReadOnlyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8338c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
